<ng-table 
    [config]="config" 
    [columns]="columns"
    [data]="updatesData"
    (cellClicked)="onCellClick($event)"
></ng-table>
